export default __webpack_public_path__ + "static/media/0145.427ccc1c.png";